var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { faDollarSign, faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textfield } from "syf-component-library/ui/atoms";
import { Stack } from "syf-component-library/ui/spacing";
import validateNumberInput from "./helpers";
import idPrefix from "../../../../const/idPrefix";
import { useEditProfileContext } from "../../../../context/editProfileContext";
import checkIsTablet from "../../../../helpers/checkIsTablet";
import getFormRulesMessages from "../../../../helpers/getFormRulesMessages";
import ProfileRow from "../../../molecules/ProfileRow";
import { RowInput } from "../../../subcomponents";
import { TooltipIncome } from "../subcomponents";
import { ControllerTooltipWrapper, TooltipWrapper } from "./subcomponents";
import theme from "../../../theme";
var IncomeSection = function () {
    var t = useTranslation().t;
    var rulesMessages = getFormRulesMessages();
    var isTablet = useEditProfileContext().isTablet;
    var _a = useFormContext(), control = _a.control, isSubmitting = _a.formState.isSubmitting;
    return (_jsx(ProfileRow, __assign({ title: t("labels.income") }, { children: _jsxs(RowInput, __assign({ "data-private": true }, { children: [_jsx(Stack, { size: "medium" }), _jsxs(ControllerTooltipWrapper, { children: [_jsx(Controller, { name: "annualNetIncome", control: control, rules: {
                                validate: rulesMessages.validateIncome,
                            }, render: function (_a) {
                                var _b = _a.field, name = _b.name, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, error = _a.fieldState.error;
                                return (_jsx(Textfield, { id: idPrefix("annual-net-income"), name: name, type: "text", placeholder: t("labels.annualIncome"), error: t((error === null || error === void 0 ? void 0 : error.message) || ""), onChange: onChange, isDisabled: isSubmitting, onBlur: onBlur, onKeyPress: function (event) {
                                        validateNumberInput(event);
                                    }, value: value, inputMode: "numeric", width: checkIsTablet(isTablet, "496px"), leftIcon: _jsx(FontAwesomeIcon, { icon: faDollarSign }) }));
                            } }), _jsx(TooltipWrapper, { children: _jsx("span", __assign({ role: "tooltip" }, { children: _jsx(TooltipIncome, __assign({ placement: "top-start", id: idPrefix("annual-net-income-tooltip-content"), content: _jsx("div", __assign({ style: {
                                            fontSize: 16,
                                            lineHeight: 1.3,
                                            margin: 1,
                                        } }, { children: t("forms.tooltips.annualIncome") })), isInteractive: true }, { children: _jsx(FontAwesomeIcon, { icon: faInfoCircle, color: theme.cyanBlue }) })) })) })] }), _jsx(Stack, { size: "medium" })] })) })));
};
export default IncomeSection;
